import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn's class merger. Required by every component copied from the registry. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
